/* eslint-disable jsx-a11y/anchor-is-valid */
import 'react-tooltip/dist/react-tooltip.css';
import './CustomTooltip.scss';
import { FC, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { ECustomTooltipPlacement, TCustomTooltip } from './CustomTooltip.type';

const CustomTooltip: FC<TCustomTooltip> = ({
  children,
  message,
  isOnClick = false,
  placement = ECustomTooltipPlacement.top,
  slug,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => setIsOpen(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleMouseEnter = () => {
    if (!isOnClick) setIsOpen(true);
  };

  const handleClick = () => {
    if (isOnClick) setIsOpen(!isOpen);
  };

  const handleMouseLeave = () => {
    if (isOpen && !isOnClick) setIsOpen(false);
  };

  return (
    <div className="CustomTooltip">
      <a
        data-tooltip-id={`FPO_Custom_Tooltip ${slug}`}
        data-tooltip-html={`<div class="FPO_Custom_Tooltip_Content">${message}</div>`}
        data-tooltip-place={placement}
        onMouseEnter={handleMouseEnter}
        onClick={handleClick}
        onMouseLeave={handleMouseLeave}
        className="FPO_Custom_Tooltip_Wrapper"
      >
        {children}
      </a>
      <Tooltip
        id={`FPO_Custom_Tooltip ${slug}`}
        className="FPO_Custom_Tooltip_Container"
        closeEvents={{
          blur: true,
          click: true,
          mouseout: !isOnClick,
          mouseleave: !isOnClick,
        }}
        isOpen={isOpen}
      />
    </div>
  );
};

export default CustomTooltip;
